import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { preloadImage } from '@jane/bloom/resources/meta/preloadImage';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.($storeSlug).rows.$customRowId.$slug/route';
import {
  MAGIC_ROW,
  getMagicRowLabel,
} from '@jane/bloom/utils/dm/getMagicRowLabel';

export const customRowRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { canonicalMenuUrl, customSEO, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  const aboveTheFoldImages = (data?.menuProductImgsAboveTheFold || [])
    .map((product) => product.imageSrcSet?.fallbackSrc)
    .filter((value, index, array) => array.indexOf(value) === index);

  const customRowName =
    data?.customRow?.row_type === MAGIC_ROW
      ? getMagicRowLabel()
      : data?.customRow?.display_name || data?.customRow?.row_type;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps, {
    rowName: customRowName,
  });

  return [
    getMetaTitle(customSEO?.customRow, metaVariables),
    getMetaDescription(customSEO?.customRow, metaVariables),
    canonicalTag(args.location, canonicalMenuUrl),
    ...aboveTheFoldImages.map(preloadImage),
    ...parentMeta(args),
  ];
};
